import VueLib from 'vue'
import merge from 'lodash.mergewith'
import * as Sentry from '@sentry/browser'

import { Dedupe, ExtraErrorData, RewriteFrames, Vue } from '@sentry/integrations'

// eslint-disable-next-line require-await
export default async function (ctx, inject) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {
    release:"0.6.32",
    dsn:"https:\u002F\u002Fcec028fbd83346df8ed762cf1757251a@sentry.delfi.net\u002F89",
    environment:"production",
    sampleRate:0.5,
    tracesSampleRate:0.5,
    allowUrls:[new RegExp("https?:\\\u002F\\\u002F([a-z0-9]*\\.)?(?:delfi|dcdn)\\.(?:ee|net|lv|lt)", "")],
    denyUrls:[new RegExp("g\\.delfi\\.lt\\\u002Fscms", ""),new RegExp("g\\.delfi\\.lt\\\u002Fmisc\\\u002Frembi", "")],
  }

  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  config.integrations = [
    new Dedupe(),
    new ExtraErrorData(),
    new RewriteFrames(),
    new Vue({ Vue: VueLib, ...{"attachProps":true,"logErrors":false}}),
  ]

  /* eslint-enable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  Sentry.init(config)

  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
